exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-a6fa6040]{height:1.3em;text-align:center}.blue-container[data-v-a6fa6040]{border-radius:5px;background-color:#0078b6}", ""]);

// exports
